// Wallet extensions (MetaMask's inpage.js etc.) reject their own internal promises when
// their background worker is unreachable. Those are not app errors, but the dev overlay
// shows every unhandled rejection and keeps reopening. Capture-phase listeners run before
// the overlay's, so stop extension-originated errors here and let everything else through.
const EXTENSION_URL = /(chrome|moz|safari(-web)?)-extension:\/\//;

function fromExtension(error, filename = '') {
  return EXTENSION_URL.test(filename) || EXTENSION_URL.test(String(error?.stack || ''));
}

function swallow(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}

if (typeof window !== 'undefined') {
  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (fromExtension(event.reason)) swallow(event);
    },
    true
  );
  window.addEventListener(
    'error',
    (event) => {
      if (fromExtension(event.error, event.filename)) swallow(event);
    },
    true
  );
}
